module.exports = __webpack_public_path__ + "static/img/center-bg.40bab70d.png";